// extracted by mini-css-extract-plugin
var _1 = "FileIconPreview-moduleicon__wDz2Z FileIconPlaceholder-modulefileIconPlaceholder__ZGAvo FileIcon-moduleFileIcon__sDjTw IconNG-moduleiconContainer__SxWZ0";
export { _1 as "icon" }
